var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-fullscreen',[_c('password-form',{attrs:{"title":_vm.$t('label.reset_password'),"submit":_vm.submit,"external-error":_vm.error}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }